export const blockIconsTravelBeachAccessNew = (
	<span className='material-symbols-outlined'>beach_access</span>
);
